import { Base } from '../../../../../common/models';
import { AutomotiveAftermarketListFiltersModel } from './automotive-aftermarket-list-filters.model';
import { DEFAULT_PAGE_SIZE_OPTIONS, ListQueryParam } from '../../../../../common/constants';

export class AutomotiveAftermarketSearchCriteria extends AutomotiveAftermarketListFiltersModel {
  [ListQueryParam.Size] = DEFAULT_PAGE_SIZE_OPTIONS[1];
  [ListQueryParam.Page] = 0;
  id?: number;
  name?: string;
  constructor(params?: AutomotiveAftermarketSearchCriteria | Base) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
